import { useCallback, useRef, useState } from "react";

/**
 * Tracks opportunity IDs discovered during the current session so they can
 * be highlighted in the UI. Cleared on page reload (in-memory only).
 */
export function useNewOpportunityIds() {
  const [newIds, setNewIds] = useState<Set<number>>(new Set());
  const newIdsRef = useRef(newIds);

  const markAsNew = useCallback((ids: number[]) => {
    const next = new Set([...newIdsRef.current, ...ids]);
    newIdsRef.current = next;
    setNewIds(next);
  }, []);

  return { newIds, markAsNew };
}
